import get from "lodash/get";
export default state =>
  get(state, "category.childLinks", []).map(childLink => ({
    ...childLink,
    linkUrl: `${childLink.linkUrl}&ctaref=cat_header`
  }));
